import PropTypes from 'prop-types';
import React from 'react';

class MeasureWeightingForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = { total: 0 };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    if (this.props.measure_weight.measure_weights) {
      let totalValue = 0;
      this.props.measure_weight.measure_weights.forEach((r) => {
        const rValue = parseFloat(r.weight) || 0;
        totalValue += rValue;
      });
      this.setState({ total: totalValue });
    }
  }

  handleChange() {
    let inputs = document.querySelectorAll('.weight-percent');
    let totalValue = 0;
    inputs.forEach((input) => {
      const userValue = parseFloat(input.value) || 0;
      totalValue += userValue;
    });

    this.setState({ total: totalValue });
  }

  render() {
    return (
      <div
        id="MeasureWeightingForm"
        className="shadow overflow-hidden px-4 py-5 bg-white sm:p-6 sm:rounded-md"
      >
        <div>
          {this.props.measure_weight.errors &&
            this.props.measure_weight.errors.base.length > 0 && (
              <div id="error_explanation">
                <p>
                  {' '}
                  {this.props.measure_weight.errors.base.length > 1
                    ? `${this.props.measure_weight.errors.base.length} errors`
                    : '1 error'}{' '}
                  prohibited the weights from being saved:
                </p>
                <ul>
                  {this.props.measure_weight.errors.base.map((error) => (
                    <li>{error}</li>
                  ))}
                </ul>
              </div>
            )}
        </div>
        <div className="grid grid-cols-2">
          <div className="col-span-1 font-medium text-gray-700">Measure</div>
          <div className="col-span-1 col-start-2 font-medium text-gray-700">
            Weight(%)
          </div>
        </div>
        {this.props.measures.map((measure, index) => (
          <div className="grid grid-cols-2 py-3" key={measure.name}>
            <div className="col-span-1">
              <label className="block  text-gray-700">{measure.name}</label>
              <input
                type="hidden"
                value={measure.id}
                id="measure_weights_measure_weights__measure_config_id"
                name="measure_weights[measure_weights][][measure_config_id]"
                className="measure w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm: border border-gray-300 rounded-md"
              ></input>
            </div>
            <div className="col-start-2">
              <input
                type="number"
                readOnly={false}
                defaultValue={
                  this.props.measure_weight.measure_weights
                    ? this.props.measure_weight.measure_weights[index].weight
                    : 0
                }
                onChange={this.handleChange}
                id={`${measure.name}__weight`}
                name="measure_weights[measure_weights][][weight]"
                className="weight-percent w-7/12 px-2 mt-1 focus:ring-indigo-500 focus:border-indigo-500 block shadow-sm sm: border border-gray-300 rounded-md"
              ></input>
            </div>

            <input
              type="hidden"
              id="measure_weights_measure_weights__client_id"
              name="measure_weights[measure_weights][][client_id]"
              value={this.props.client}
            />
          </div>
        ))}

        <div className="col-span-1 col-start-2 grid grid-cols-2">
          <div className="col-span-1  font-medium text-gray-700">Total</div>
          <div
            id="totalCounter"
            className={
              this.state.total == 100
                ? 'text-green-600 col-span-1 col-start-2'
                : 'text-red-600 col-span-1 col-start-2'
            }
          >
            {this.state.total} / 100%
          </div>
        </div>

        <div className="actions">
          <input type="submit" value="Submit" />
          <a class="secondary-btn ml-2" href="/weights_targets">Cancel</a>
        </div>
      </div>
    );
  }
}

MeasureWeightingForm.propTypes = {
  client: PropTypes.number,
  retailers: PropTypes.array,
};

export default MeasureWeightingForm;
